import { CardSizeInfo } from '../cms/CardSizeInfo';
import { GridDataSource } from '../cms/GridDataSource';
import { RecordingCardDataSource } from './RecordingCardDataSource';
import { CardType, CmsProperty } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { Recording } from '../../api/user/RecordingApi.types';
import { IRibbon2Asset } from '../../api/models/AndromeTV.types';
import { CardDataSource } from '../cms/CardDataSource';

export class RecordingFolderGridDataSource extends GridDataSource {
  private recordings: Recording[];
  constructor(
    backend: Backend,
    title: string,
    recordings: Recording[],
    channels: ChannelModel[],
    properties: CmsProperty[]
  ) {
    // TODO grid object
    super(backend, { title: title, url: '', properties: [] }, properties, channels);
    this.backend = backend;
    this.channels = channels;
    this.sizeInfo = new CardSizeInfo(true);
    this.recordings = recordings;
  }

  override load(): Promise<RecordingFolderGridDataSource> {
    return new Promise(resolve => {
      this.hasNextPage = false;
      const cards: RecordingCardDataSource[] = [];
      this.recordings.forEach(recording => {
        cards.push(
          new RecordingCardDataSource(this.backend, [recording], this.channels, this.sizeInfo, this.cmsProperties)
        );
      });
      Promise.all(cards.map(card => card.toRibbon2Asset())).then(assets => {
        const filteredAssets = assets.filter(a => a) as IRibbon2Asset[];
        this.items = cards.map(card => card.datasource).filter(c => c) as CardDataSource[];
        this.sizeInfo.updateWithContainer(
          {
            items: filteredAssets,
            type: CardType.Landscape,
            nextPage: false,
          },
          this.cmsProperties
        );
        resolve(this);
      });
    });
  }
}
